import React from "react";
import { Box } from "@mui/material";

/**
 * Plays a widescreen MP4 inside a square board, showing only the center crop region.
 * Default: 1280×720 source → center 720×720 (280px side bands cropped).
 */
export default function AnimationCenterCropVideo({
    src,
    sourceWidth = 1280,
    sourceHeight = 720,
    cropSize = 720,
    autoPlay = true,
    loop = false,
    muted = true,
    onEnded,
}) {
    if (!src) return null;

    const cropX = Math.max(0, (sourceWidth - cropSize) / 2);
    const cropY = Math.max(0, (sourceHeight - cropSize) / 2);
    const widthPct = (sourceWidth / cropSize) * 100;
    const heightPct = (sourceHeight / cropSize) * 100;
    const offsetXPct = -(cropX / cropSize) * 100;
    const offsetYPct = -(cropY / cropSize) * 100;

    return (
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                zIndex: 10,
                bgcolor: "#000",
            }}
        >
            <Box
                component="video"
                src={src}
                autoPlay={autoPlay}
                loop={loop}
                muted={muted}
                playsInline
                onEnded={onEnded}
                sx={{
                    position: "absolute",
                    display: "block",
                    width: `${widthPct}%`,
                    height: `${heightPct}%`,
                    left: `${offsetXPct}%`,
                    top: `${offsetYPct}%`,
                    objectFit: "fill",
                }}
            />
        </Box>
    );
}
